<script>
  export let size = "24";
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_26036_232781)">
    <path
      d="M16.9681 8.76094C16.9681 13.2021 13.4886 16.49 8.99999 16.49C8.19393 16.49 7.42039 16.3836 6.69337 16.1837C6.55218 16.1445 6.40206 16.1557 6.26788 16.2146L4.68636 16.913C4.27266 17.0956 3.80572 16.8014 3.79202 16.3495L3.74867 14.9318C3.74325 14.7571 3.66485 14.5939 3.53449 14.4776C1.98389 13.0911 1.03186 11.0841 1.03186 8.76094C1.03186 4.31983 4.51138 1.03186 8.99999 1.03186C13.4886 1.03186 16.9681 4.31983 16.9681 8.76094Z"
      style="fill: #0866FF !important;"
    />
    <path
      d="M11.1635 10.986L13.9377 6.69848C14.2166 6.26756 13.7 5.76589 13.2773 6.05752L10.3814 8.05498C10.2839 8.12223 10.1551 8.12414 10.0557 8.05976L7.48514 6.39665C7.26745 6.25577 6.97709 6.31824 6.83653 6.53561L4.06203 10.8231C3.78315 11.254 4.2998 11.7557 4.72243 11.4641L7.619 9.46629C7.71653 9.39904 7.8453 9.39713 7.94474 9.46151L10.5146 11.1243C10.7323 11.2652 11.0227 11.2027 11.1635 10.9853V10.986Z"
      style="fill: white !important;"
    />
  </g>
  <defs>
    <clipPath id="clip0_26036_232781">
      <rect width="16" height="16" fill="white" transform="translate(1 1)" />
    </clipPath>
  </defs>
</svg>